function location_detect() {
    let element = document.querySelector('.uk_only');

    if( element ) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(is_uk__rough, show_error);
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }
    
}

function is_uk__rough(position) {

    let lat = position.coords.latitude,
        lng = position.coords.longitude;

    // a rough box direct from google maps, including a sliver of France
    const uk_box = {
        top_left_lat: 58.66744307499713,
        top_left_lng: -10.600520148470194,
        bottom_right_lat: 50.010124456975966,
        bottom_right_lng: 1.8579761870463267
    }

    // Tests
    // Belgium
    // lat = 50.21910853334952;
    // lng = 4.9578587135832946;

    if(
        uk_box.top_left_lat > lat &&
        uk_box.bottom_right_lat < lat &&
        uk_box.top_left_lng < lng &&
        uk_box.bottom_right_lng > lng
    ) {
        document.body.classList.toggle('is_uk__rough');
        // console.log(lat + ', ' + lng);
        // console.log('is_uk__rough');
    } else {
        document.body.classList.toggle('not_uk__rough');
        // console.log(lat + ', ' + lng);
        // console.log('not_uk');
    }

}

function show_error(error) {
    document.body.classList.toggle('is_uk__unknown');
    switch(error.code) {
      case error.PERMISSION_DENIED:
        console.log("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
        console.log("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        console.log("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        console.log("An unknown error occurred.");
        break;
    }
}

location_detect();